import { render, staticRenderFns } from "./pointChart.vue?vue&type=template&id=126c7f1c&scoped=true"
import script from "./pointChart.vue?vue&type=script&lang=js"
export * from "./pointChart.vue?vue&type=script&lang=js"
import style0 from "./pointChart.vue?vue&type=style&index=0&id=126c7f1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126c7f1c",
  null
  
)

export default component.exports